import { Star, Quote } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export const TestimonialsSection = () => {
  const { testimonials } = useSite();
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className="bg-[#F5F5F0] py-16 md:py-24" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Ce que nos clients disent</h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            La satisfaction de nos clients est notre priorité.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm" data-testid={`testimonial-${t.id}`}>
              <Quote className="w-8 h-8 text-[#2D5A3D]/20 mb-3" />
              <p className="text-gray-700 leading-relaxed mb-4 text-sm">"{t.text}"</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{t.name}</p>
                  {t.city && <p className="text-xs text-gray-500">{t.city}</p>}
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={`${t.id}-star-${j}`} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
